module.exports = __webpack_public_path__ + "img/LogoExitusMujer_Color.b84f4849.png";